export default __webpack_public_path__ + "static/media/whiteT.4776b358.jpg";